<ng-container *transloco="let t; scope: 'cms'">
  <section class="newsletter block margin--bottom-l margin--top-l">
    <div
      *ngIf="data?.background?.formats?.large"
      class="bg-section bg-section--image remove-margin-bottom"
      style="background-image: url('{{ data.background.formats?.large?.url }}')"
    >
      <div class="default-padding">
        <div class="default-max-width centered text-centered">
          <h4 class="headline-second">{{ data.title }}</h4>

          <div class="default-text margin--bottom-m">
            <p>{{ data.description }}</p>
          </div>

          <div class="grid">
            <div class="grid__item desk--one-third">
              <form class="form default-font-sizes" action="#">
                <input
                  type="email"
                  id="email"
                  name="email"
                  class="input-text input-text--large"
                  placeholder="{{ t('cms.ui-newsletter.newsletter.mail-address') }}"
                />

                <br />

                <input type="submit" class="btn btn--wide btn--uppercase" value="{{ data.button }}" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-container>
